import { IContact } from "@rentiohq/shared-frontend/dist/types/contact.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Form } from "@rentiohq/web-shared-next/dist/ui-components";
import { IFormikValues } from "@rentiohq/web-shared-next/dist/utils/types/form";
import { completeContactSchema } from "../../../forms/completeContact";

export interface IProps {
  openDialog: boolean;
  selectedContact?: IContact;
  onClose: () => void;
  onSubmit: (formData: IFormikValues) => void;
  isLoading?: boolean;
}

export const CompleteContactModal = (props: IProps) => {
  const { openDialog, selectedContact, onClose, onSubmit, isLoading } = props;

  // if (!openDialog) {
  //   return null;
  // }

  return (
    <Form
      renderAsModal={true}
      onSubmit={onSubmit}
      getSchema={completeContactSchema({
        isCompany: true,
        showSendInvite: true,
        contact: selectedContact,
      })}
      isSubmitting={isLoading}
      asMultiStep={true}
      modalProps={{
        modalTitle: getLocalizedText(
          "contact.complete_remaining_data.modal.title",
        ),
        openDialog,
        handleClose: onClose,
        maxWidth: "1000px",
        width: "1000px",
      }}
    />
  );
};
